/**
 * @generated SignedSource<<896fa16e7750ce03d6a52823820058e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSourceInput = {
  clientMutationId?: string | null;
  sourceId: string;
};
export type SourceListTab_Mutation$variables = {
  input: DeleteSourceInput;
  connections: ReadonlyArray<string>;
};
export type SourceListTab_MutationVariables = SourceListTab_Mutation$variables;
export type SourceListTab_Mutation$data = {
  readonly deleteSource: {
    readonly deletedSourceId: string;
  } | null;
};
export type SourceListTab_MutationResponse = SourceListTab_Mutation$data;
export type SourceListTab_Mutation = {
  variables: SourceListTab_MutationVariables;
  response: SourceListTab_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedSourceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceListTab_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteSourcePayload",
        "kind": "LinkedField",
        "name": "deleteSource",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SourceListTab_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteSourcePayload",
        "kind": "LinkedField",
        "name": "deleteSource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedSourceId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "49503e36664229e172976565aafaf2db",
    "id": null,
    "metadata": {},
    "name": "SourceListTab_Mutation",
    "operationKind": "mutation",
    "text": "mutation SourceListTab_Mutation(\n  $input: DeleteSourceInput!\n) {\n  deleteSource(input: $input) {\n    deletedSourceId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fa392933b08ef02a85532974a7c3358";

export default node;
